import { render, staticRenderFns } from "./HistoriqueCommandes.vue?vue&type=template&id=3e895d70&scoped=true"
import script from "./HistoriqueCommandes.vue?vue&type=script&lang=js"
export * from "./HistoriqueCommandes.vue?vue&type=script&lang=js"
import style0 from "./HistoriqueCommandes.vue?vue&type=style&index=0&id=3e895d70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e895d70",
  null
  
)

export default component.exports